module.exports = __webpack_public_path__ + "img/align-end.c7e8ef70.svg";